<ng-container *ngIf="formats.length || certificateItem; then multiple; else simple"></ng-container>

<ng-template #multiple>
  <ng-container *ngIf="!isMoreOption">
    <ng-container *ngIf="certificateItem; else defaultSection">
      <button
        class="accent multiple-actions transparent certificate-button"
        mat-flat-button
        appStopPropagation
        [matMenuTriggerFor]="checkoutMenu">
        <div class="certificate-section">
          <span> {{buttonLabel | translateByCustomerType:customerType.dbValue}} </span>
          <span class="odilo-icon" aria-hidden="true">navigate_downward</span>
        </div>
        <mat-menu #checkoutMenu="matMenu" yPosition="below" xPosition="before">
          <button mat-menu-item class="mat-menu-item" appStopPropagation (click)="downloadCertificate()">
            <span class="odilo-icon" aria-hidden="true">download</span> {{'general.download' | translate}}
          </button>
          <button mat-menu-item appStopPropagation (click)="shareCertificateOnLinkedin()">
            <span class="odilo-icon" aria-hidden="true">linkedin</span> {{'social.button.label.linkedin' | translate}}
          </button>
        </mat-menu>
      </button>
    </ng-container>
    <ng-template #defaultSection>
      <button class="accent multiple-actions"
        mat-flat-button
        appStopPropagation
        (click)="download()">
        <span class="text">
          {{buttonLabel | translateByCustomerType:customerType.dbValue}}
        </span>
        <mat-menu #checkoutMenu="matMenu" yPosition="below" xPosition="before">
          <button mat-menu-item
            appStopPropagation
            (click)="download(defaultFormat)" class="default">
            {{getActionLabel(defaultFormat) | translateByCustomerType:customerType.dbValue}}
            <span class="odilo-icon" aria-hidden="true">check</span>
          </button>
          <button mat-menu-item
            *ngFor="let format of formats"
            appStopPropagation
            (click)="download(format)">
            {{getActionLabel(format) | translateByCustomerType:customerType.dbValue}}
          </button>
        </mat-menu>

        <button mat-flat-button
          class="only-icon only-icon--down"
          appStopPropagation
          [dir]="textDirection"
          [matMenuTriggerFor]="checkoutMenu"
          [attr.aria-label]="'general.viewMore' | translate">
          <span class="odilo-icon" aria-hidden="true">navigate_downward</span>
        </button>
      </button>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="isMoreOption">
    <mat-menu #checkoutMenu="matMenu">
      <button mat-menu-item appStopPropagation (click)="download(defaultFormat)" class="default">
        {{ getActionLabel(defaultFormat) | translateByCustomerType: customerType.dbValue }}
        <span class="odilo-icon" aria-hidden="true">check</span>
      </button>
      <button mat-menu-item *ngFor="let format of formats" appStopPropagation (click)="download(format)">
        {{ getActionLabel(format) | translateByCustomerType: customerType.dbValue }}
      </button>
    </mat-menu>
    <button mat-menu-item class="only-icon download__item" [dir]="textDirection" [matMenuTriggerFor]="checkoutMenu">
      <span class="download__item-text">
        <span class="odilo-icon" aria-hidden="true">{{ record?.icon?.icon }}</span>
        {{ buttonLabel | translateByCustomerType: customerType.dbValue }}
      </span>
      <span class="odilo-icon arrow" aria-hidden="true">navigate_next</span>
    </button>
  </ng-container>
</ng-template>

<ng-template #simple>
  <button
    *ngIf="!isMoreOption"
    class="accent"
    mat-flat-button
    appStopPropagation
    (click)="download()"
    [attr.aria-label]="buttonLabel | translateByCustomerType: customerType.dbValue">
    <span class="text" aria-hidden="true">{{ buttonLabel | translateByCustomerType: customerType.dbValue }}</span>
  </button>
  <button
    *ngIf="isMoreOption"
    mat-menu-item
    appStopPropagation
    (click)="download()"
    [attr.aria-label]="buttonLabel | translateByCustomerType: customerType.dbValue">
    <span class="odilo-icon" aria-hidden="true">{{ record?.icon?.icon }}</span>
    <span class="text" aria-hidden="true">{{ buttonLabel | translateByCustomerType: customerType.dbValue }}</span>
  </button>
</ng-template>

<opac-recaptcha-dialog (resolved)="resolvedCaptcha($event)"></opac-recaptcha-dialog>
